import { jwtDecode } from "jwt-decode";

interface DecodedToken {
  roles: string[] | string;
}

export const checkPermission = (requiredPermission: string): boolean => {
  let roles: string[] = [];

  const tokenStr = localStorage.getItem("token") || sessionStorage.getItem("token");
  if (!tokenStr) return false;

  try {
    // Try to parse as JSON object (API response)
    const parsed = JSON.parse(tokenStr);
    if (parsed && Array.isArray(parsed.roles)) {
      roles = parsed.roles;
    } else if (parsed && parsed.data && Array.isArray(parsed.data.roles)) {
      roles = parsed.data.roles;
    } else if (parsed && typeof parsed.token === "string") {
      // If token is inside a JSON object, decode it
      const decoded = jwtDecode<DecodedToken>(parsed.token);
      roles = Array.isArray(decoded.roles) ? decoded.roles : decoded.roles.split(",");
    }
  } catch {
    // If not JSON, treat as plain JWT
    try {
      const decoded = jwtDecode<DecodedToken>(tokenStr);
      roles = Array.isArray(decoded.roles) ? decoded.roles : decoded.roles.split(",");
    } catch (err) {
      return false;
    }
  }

  return roles.includes(requiredPermission);
};